import MediaQueries from './MediaQueries';

let getBreakpoint = '';

if (MediaQueries.xs.matches) {
  getBreakpoint = 'xs';
}
if (MediaQueries.sm.matches) {
  getBreakpoint = 'sm';
}
if (MediaQueries.md.matches) {
  getBreakpoint = 'md';
}
if (MediaQueries.lg.matches) {
  getBreakpoint = 'lg';
}
if (MediaQueries.xl.matches) {
  getBreakpoint = 'xl';
}

export default getBreakpoint;
